import { environment } from 'src/environment';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ParentalControlService } from 'src/app/core/services/parental-control.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { AgeLimit, ParentalControl } from 'src/app/shared/models';
import * as uikit from 'uikit';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-parental-control',
  templateUrl: './parental-control.component.html',
  styleUrls: ['./parental-control.component.scss', "../modal-screens.scss"]
})
export class ParentalControlComponent implements OnInit, OnChanges {

  @Input() parentalControl: ParentalControl;
  @Output() updateAccountData = new EventEmitter();
  step: number; // [1 - configuration, 2 - Enter Pin, 3 - Success] 
  isParentalButtonOn: boolean;
  sliderConfig;
  selectedAgeLimit: AgeLimit;
  parentalControlForm : FormGroup;
  actualAgeLimitIndex: number;
  @ViewChild('activeBarRef') activeBar: ElementRef;
  @ViewChild('ngOtpInput') ngOtpRef;
  pinErrorMsg:string;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '45px',
      height: '50px'
    },
    inputClass: 'parent-pin-input',
    containerClass: 'otp-container-class'
  }
  responseData: any;
  pin: string = '';
  parentalControlAgeSubs;
  ageListLength = 0;
  enablePinBtn = true;
  loadOTP = false;
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private fb: FormBuilder,
              private parentalService: ParentalControlService, private uikitService: UikitService,
              private analyticsService: InhouseAnalyticsService) {
    this.step = 1;
    uikit.util.on(document, 'beforehide', '#parental-control-modal', ()=> this.resetData());
  }

  resetData(){
    this.loadOTP = false;
    this.enablePinBtn = !Boolean(this.parentalControl.is_pin_already_set);
    this.isParentalButtonOn = Boolean(this.parentalControl.is_parental_control_enabled)
    if(this.step == 3 || (this.step == 1 && !this.isParentalButtonOn)) {
      this.updateAccountData.emit();
      return;
    }
    this.step = 1;
    this.parentalControlForm.controls.is_parental_control_enabled.setValue(this.isParentalButtonOn)
    this.parentalControlForm.controls.age_limit_value_index.setValue(this.actualAgeLimitIndex >= 0 ? this.actualAgeLimitIndex : '');
    this.activeBar.nativeElement.style.width = 0;
  }
  ngOnChanges() {
    this.step = 1;
    this.ngOnInit();
  }
  ngOnInit(): void {
    this.enablePinBtn = !Boolean(this.parentalControl.is_pin_already_set);
    this.config.placeholder = this.parentalControl.is_pin_already_set ? '*' : '';
    this.isParentalButtonOn = Boolean(this.parentalControl.is_parental_control_enabled);
    this.actualAgeLimitIndex  = this.parentalControl.age_limits.findIndex(limit => limit.value == this.parentalControl.set_age_limit);
    this.selectedAgeLimit = this.parentalControl.age_limits[this.actualAgeLimitIndex];
    this.parentalControlForm = this.fb.group({
      age_limit_value_index : [this.actualAgeLimitIndex > -1 ? this.actualAgeLimitIndex : '',  Validators.compose([Validators.required])],
      update_pin : [''],
      old_pin : [''],
      age_limit_value: this.parentalControl.set_age_limit,
      is_parental_control_enabled: [this.isParentalButtonOn]
    })
    this.ageListLength = this.parentalControl.age_limits.length
    setTimeout(() => this.activeBar.nativeElement.style.width = this.ageBarWidth);
    this.parentalControlAgeSubs = this.parentalService.setLimitAge.subscribe((value)=> {
      this.parentalControl.set_age_limit = value;
      this.activeBar.nativeElement.style.width = ((value/(this.ageListLength+1)) * 100) + '%';
    });
  }

  setAgeBar() {
    if(this.parentalControl.is_pin_already_set) this.activeBar.nativeElement.style.width = this.ageBarWidth;
    else this.activeBar.nativeElement.style.width = 0;
  }

  get ageBarWidth() {
    return (((this.actualAgeLimitIndex+1)/(this.ageListLength+1)) * 100) + '%';
  }

  toggleButtonChange(event) {
    this.isParentalButtonOn = event.checked;
  }

  async turnParentalControlOff() {
    // if(this.parentalControl.is_parental_control_enabled == this.parentalControlForm.controls.is_parental_control_enabled.value) return;
    try {
      const postData = {
        access_pin: '',
        age_limit_value: this.parentalControl.set_age_limit,
        is_parental_control_enabled: 0,
      }
      if(+this.parentalControl.set_age_limit <= 0) {
        document.getElementById('pin-close').click();
      } else {
        await this.parentalService.setParentalControl(postData).toPromise();
        this.updateAccountData.emit();
        document.getElementById('pin-close').click();
      }
    } catch (error) {
      console.log(error)
    }
  }

  changeToStepTwo() {
    this.parentalControlForm.markAllAsTouched();
    if(!this.parentalControlForm.valid) return;
    this.step = 2;
    /*SPI-I690: Avoid autofill password*/
    setTimeout(()=> this.loadOTP = true,850);
    // setTimeout(()=> {
    //   this.config.allowNumbersOnly = false;
      // if(this.parentalControl.is_pin_already_set && this.settingsService.parentalControlModuleEnabled && this.ngOtpRef.otpForm){
      //   const setOTPValue = {ctrl_0:'*',ctrl_1:'*',ctrl_2:'*',ctrl_3:'*'};
      //   this.ngOtpRef.otpForm.setValue(setOTPValue);
      //   this.enablePinBtn = false;
      //   this.pin = '****'
      // }
    // });
    // this.config.allowNumbersOnly = true;
  }

  onPinChange(pin:any) {
    this.pin = pin;
    if(this.pin.length == 4) this.enablePinBtn = false;
    else this.enablePinBtn = true
    if(this.parentalControl.is_pin_already_set && this.pin.length == 0) this.enablePinBtn = false;
  }

  handlePinSubmit(){
    if(this.parentalControl.is_pin_already_set && this.pin.length == 0) {
      this.pin = '****'
    }
    if(this.pin.length === 4){
      let postData:any = {
        access_pin: this.pin == '****' ? '' : this.pin,
        age_limit_value: this.parentalControlForm.controls.age_limit_value.value,
        is_parental_control_enabled: Number(this.parentalControlForm.controls.is_parental_control_enabled.value),
      }
      // if(this.parentalControl.is_pin_already_set == 1) {
      //   postData.update_pin = 1;
      //   postData.old_pin = 1234;
      // }
      this.parentalService.setParentalControl(postData).subscribe({
        next: data => {
          this.responseData = data;
          const eventObj = {
            event_type: 'Event',
            event_name:  Number(this.parentalControlForm.controls.is_parental_control_enabled.value) ? 'Parental Control Enable' : 'Parental Control Disable',
            event_status: 'Success',
          };
          this.analyticsService.trackUserActions(eventObj);
        }, complete: () => {
          this.step = 3;
        }, error: (err) => {
          this.uikitService.notifyError(err);
          const eventObj = {
            event_type: 'Event',
            event_name:  Number(this.parentalControlForm.controls.is_parental_control_enabled.value) ? 'Parental Control Enable' : 'Parental Control Disable',
            event_status: 'Success',
            event_description: err
          };
          this.analyticsService.trackUserActions(eventObj);
        }
      })
    }else{
      this.pinErrorMsg = 'Incomplete Pin'
      this.uikitService.staticErrorMessage(this.pinErrorMsg);
    }
  }
  ngOnDestroy() {
    try {
      this.parentalControlAgeSubs.unsubscribe();
    } catch (error) {
      console.log(error)
    }
  }
}
